import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import { sideNavPrimaryMenu } from "../../../../configs/protectedSideNav.config";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { changeActiveMenu } from "../../../../store/slice/setup.slice";

const { Sider } = Layout;

interface ProtectedSideNavInterface {}

const ProtectedSideNav: React.FC<ProtectedSideNavInterface> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [sidebarOpened, setSidebarOpened] = useState(true);

  useEffect(() => {
    changeMenu(location?.pathname);
  }, [location]);

  const changeMenu = (key?: string) => {
    dispatch(changeActiveMenu(key));
  };

  const state = useAppSelector((state) => state);

  const { activeMenu } = state.setup;

  return (
    <Sider
      id="sidebar"
      breakpoint="lg"
      collapsedWidth="0"
      collapsed={window.innerWidth < 992 ? sidebarOpened : false}
      onCollapse={(val?: any) => {
        setSidebarOpened(val);
      }}
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={["/store"]}
        onClick={(e?: any) => {
          changeMenu(e.key);
          ReactGA.event({
            category: "Store",
            action: `Side menu clicked - ${e?.key}`,
            label: "",
            nonInteraction: true, // optional, true/false
            transport: "xhr",
          });
        }}
        selectedKeys={[activeMenu]}
      >
        {sideNavPrimaryMenu?.map((menu, menuIndex) => {
          return (
            <Menu.Item key={menu?.slug} className="sidebar__menu__item">
              <NavLink
                to={menu?.slug}
                className="sidebar__menu__item__link"
                onClick={() => {
                  setSidebarOpened(true);
                }}
              >
                {menu?.name}
              </NavLink>
            </Menu.Item>
          );
        })}
      </Menu>
      {/* <LikedYourSpace /> */}
    </Sider>
  );
};

export default ProtectedSideNav;
